
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"nonzero","d":"M23.6 9.5c-.266 0-.521.042-.762.12a6.47 6.47 0 00-1.682-1.077A4.746 4.746 0 0023.05 4.75C23.05 2.13 20.92 0 18.3 0s-4.75 2.13-4.75 4.75c0 1.256.49 2.4 1.29 3.25h-4.08a4.733 4.733 0 001.29-3.25C12.05 2.13 9.92 0 7.3 0S2.55 2.13 2.55 4.75c0 1.548.744 2.925 1.894 3.793a6.472 6.472 0 00-1.682 1.076A2.49 2.49 0 002 9.5c-1.103 0-2 .897-2 2v2.25a.75.75 0 00.55.722v6.278c0 .414.336.75.75.75h23a.75.75 0 00.75-.75v-6.278a.75.75 0 00.55-.722V11.5c0-1.103-.897-2-2-2zm.5 2V13h-.5a1.001 1.001 0 010-2 .5.5 0 01.5.5zm-9.05-6.75A3.254 3.254 0 0118.3 1.5a3.254 3.254 0 013.25 3.25A3.254 3.254 0 0118.3 8a3.254 3.254 0 01-3.25-3.25zM7.3 1.5a3.254 3.254 0 013.25 3.25A3.254 3.254 0 017.3 8a3.254 3.254 0 01-3.25-3.25A3.254 3.254 0 017.3 1.5zm-5.8 10A.5.5 0 012 11a1.001 1.001 0 010 2h-.5v-1.5zm.55 2.999A2.502 2.502 0 004.5 12c0-.55-.18-1.06-.482-1.473A4.948 4.948 0 017.05 9.5c2.757 0 5 2.243 5 5V20h-6.5v-3.25a.75.75 0 00-1.5 0V20h-2v-5.501zM21.55 20v-3.25a.75.75 0 00-1.5 0V20h-6.5v-5.5a6.49 6.49 0 00-2.351-5h7.351c1.111 0 2.165.36 3.032 1.027A2.486 2.486 0 0021.1 12a2.502 2.502 0 002.45 2.499V20h-2z"}})])
          )
        }
      }
    